'use client';
import { FC, PropsWithChildren } from 'react';

import { MicrocopyKey } from '@/data/microcopy/microcopyDictionary';
import { MicrocopyStoreProvider, useCreateMicrocopyStore } from '@/stores/microcopyStore';

export const LegacyMicrocopyStoreProviderClient: FC<
  PropsWithChildren<{
    storeData: [MicrocopyKey, string][];
  }>
> = ({ children, storeData }) => {
  const createMicrocopyStore = useCreateMicrocopyStore({
    microcopy: new Map(storeData),
  });
  return <MicrocopyStoreProvider createStore={createMicrocopyStore}>{children}</MicrocopyStoreProvider>;
};
